import togglePoint from "./components/hooks/withTogglePoint/index.js";
import handler from "@asosteam/asos-web-toggle-point-webpack/pathSegmentToggleHandler";
export default (rest) => handler({ togglePoint, ...rest });